// extracted by mini-css-extract-plugin
module.exports = {"statisticsRight":"statisticsRight___1Ad1p","imgCard":"imgCard___1kOhE","panelCard":"panelCard___11AcP","linkList":"linkList___2I1gZ","linkListItem":"linkListItem___18unx"};